import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => (
  <Svg viewBox="0 0 18 19" {...props}>
    <path
      d="M11.2562 8.43668C11.2562 8.62538 11.1389 8.78386 10.9576 8.83882C9.99022 9.13378 9.6632 9.4608 9.36824 10.429C9.31328 10.6095 9.1548 10.7268 8.9661 10.7268C8.7774 10.7268 8.61893 10.6095 8.56396 10.429C8.269 9.4608 7.94198 9.13378 6.97374 8.83882C6.79328 8.78386 6.67603 8.62538 6.67603 8.43668C6.67603 8.24798 6.79328 8.08951 6.97374 8.03455C7.94198 7.73958 8.269 7.41256 8.56396 6.44432C8.61893 6.26386 8.7774 6.14661 8.9661 6.14661C9.1548 6.14661 9.31328 6.26386 9.36824 6.44432C9.6632 7.41256 9.99022 7.73958 10.9585 8.03455C11.1389 8.08951 11.2562 8.24798 11.2562 8.43668Z"
      fill="url(#paint0_linear_425_2265)"
    />
    <path
      d="M12.1961 5.20676C11.3332 4.34386 10.1863 3.86844 8.96619 3.86844C7.74604 3.86844 6.59825 4.34386 5.73627 5.20676C4.87337 6.06966 4.39795 7.21653 4.39795 8.43668C4.39795 9.65684 4.87337 10.8046 5.73627 11.6666C6.0349 11.9652 6.36833 12.2181 6.7265 12.4205C7.14513 12.2941 7.56375 12.1191 7.98421 11.8938C7.4007 11.7289 6.86665 11.4174 6.42604 10.9768C5.74726 10.2981 5.37444 9.39577 5.37444 8.43668C5.37444 7.4776 5.74726 6.57531 6.42604 5.89653C7.10482 5.21867 8.00711 4.84493 8.96619 4.84493C9.92528 4.84493 10.8276 5.21867 11.5063 5.89653C12.1842 6.57531 12.558 7.4776 12.558 8.43668C12.558 9.07974 12.3903 9.69531 12.0761 10.2367C12.4434 10.1982 12.8126 10.1872 13.1818 10.2028C13.4126 9.65134 13.5344 9.05317 13.5344 8.43668C13.5344 7.21653 13.059 6.06966 12.1961 5.20676Z"
      fill="url(#paint1_linear_425_2265)"
    />
    <path
      d="M15.3637 2.73439C13.6635 1.03424 11.4046 0.098053 9 0.098053C6.59542 0.098053 4.33557 1.03424 2.63634 2.73439C0.936183 4.43454 0 6.69439 0 9.09805C0 10.6837 0.407634 12.2071 1.17344 13.5481C1.23023 13.6471 1.28885 13.7451 1.34931 13.8422C1.56275 14.1857 1.80092 14.5155 2.06198 14.8306C2.20855 15.0083 2.36336 15.1805 2.52458 15.3472C2.56122 15.3857 2.59878 15.4242 2.63634 15.4617C3.20428 16.0297 3.83542 16.5124 4.51328 16.9036C4.70931 17.0162 4.90901 17.1216 5.11237 17.2196C5.4458 17.379 5.7884 17.5182 6.13924 17.6355C6.31969 17.6959 6.5029 17.75 6.68794 17.7985C7.43267 17.9955 8.20855 18.0981 9 18.0981C11.2076 18.0981 13.2925 17.3084 14.935 15.8639C15.0128 15.7952 15.0898 15.7246 15.1658 15.6532C15.2327 15.5909 15.2986 15.5268 15.3637 15.4617C15.4269 15.3985 15.4892 15.3344 15.5496 15.2703C15.6174 15.1988 15.6834 15.1255 15.7484 15.0523C15.938 14.8379 16.1176 14.6153 16.2843 14.3854C16.3392 14.3112 16.3924 14.2361 16.4437 14.1591C16.5371 14.0226 16.6269 13.8843 16.7121 13.7432C16.7606 13.6636 16.8064 13.5848 16.8522 13.5042C17.6015 12.1732 18 10.6663 18 9.09805C18 6.69439 17.0638 4.43454 15.3637 2.73439ZM16.6397 11.2104C16.615 11.302 16.5893 11.3927 16.5609 11.4834C16.5105 11.6437 16.4537 11.8022 16.3933 11.9588C16.3594 12.0458 16.3246 12.1329 16.2879 12.2181C16.1725 12.4883 16.0406 12.7521 15.895 13.0086C15.8492 13.0883 15.8024 13.1689 15.7539 13.2477C15.666 13.3897 15.5734 13.5289 15.4763 13.6663C15.4214 13.7442 15.3655 13.8202 15.3078 13.8962C15.0971 14.1719 14.8681 14.4358 14.6198 14.6849C14.6144 14.6904 14.6098 14.6968 14.6043 14.7023C14.5319 14.7747 14.4577 14.8434 14.3826 14.913C14.2269 15.0577 14.0656 15.1952 13.8998 15.3261C13.7973 15.4068 13.6928 15.4855 13.5866 15.5606C12.2556 16.5097 10.6681 17.0236 9 17.0236C8.87359 17.0236 8.74809 17.0199 8.62168 17.0144C8.4513 17.0061 8.28183 16.9915 8.11328 16.9732C7.81191 16.9393 7.5142 16.8889 7.22198 16.822C7.0571 16.7845 6.89313 16.7423 6.73099 16.6947C6.09069 16.5042 5.47695 16.233 4.90443 15.8858C4.74321 15.7887 4.58657 15.6834 4.43267 15.5744C4.14504 15.371 3.87023 15.1475 3.60824 14.9039C3.53679 14.8379 3.46534 14.771 3.39573 14.7023C3.32244 14.6281 3.25191 14.5521 3.18137 14.4761C2.75634 14.0171 2.39176 13.5152 2.09038 12.982C2.01252 12.8428 1.93832 12.7026 1.8687 12.5606C1.74687 12.3106 1.63786 12.055 1.54351 11.7939C1.49679 11.6648 1.45374 11.5338 1.41344 11.4028C1.19084 10.6654 1.0745 9.89042 1.0745 9.09805C1.0745 6.98111 1.89893 4.99057 3.39573 3.49378C4.89344 1.99698 6.88305 1.17256 9 1.17256C11.1169 1.17256 13.1075 1.99698 14.6043 3.49378C16.1011 4.99149 16.9255 6.98111 16.9255 9.09805C16.9255 9.82172 16.8266 10.5307 16.6397 11.2104Z"
      fill="url(#paint2_linear_425_2265)"
    />
    <path
      d="M16.6398 11.2104C16.6151 11.302 16.5894 11.3927 16.561 11.4834C16.5106 11.6437 16.4539 11.8022 16.3934 11.9588C16.3595 12.0458 16.3247 12.1329 16.2881 12.2181C15.1238 11.5145 13.8349 11.1912 12.5671 11.248C12.6395 11.1564 12.7073 11.0629 12.7714 10.9668C12.8768 10.8083 12.9729 10.6434 13.0572 10.4739C13.1021 10.3851 13.1433 10.2944 13.1818 10.2028C14.3644 10.2559 15.5461 10.5921 16.6398 11.2104Z"
      fill="url(#paint3_linear_425_2265)"
    />
    <path
      d="M8.22951 12.9454C7.19165 13.4602 6.15104 13.7203 5.12417 13.7203H5.12234C4.12203 13.7203 3.10615 13.4721 2.09028 12.982C2.01241 12.8428 1.93822 12.7026 1.8686 12.5606C1.74677 12.3106 1.63776 12.055 1.54341 11.7939C1.49669 11.6648 1.45364 11.5338 1.41333 11.4028C1.4573 11.4174 1.49944 11.4358 1.53791 11.4614C3.28753 12.622 5.00051 12.9417 6.72631 12.4205C6.84081 12.4846 6.95806 12.5442 7.07715 12.5982C7.30432 12.7017 7.54157 12.7869 7.78432 12.851C7.92997 12.8904 8.07928 12.9216 8.22951 12.9454Z"
      fill="url(#paint4_linear_425_2265)"
    />
    <path
      d="M8.7023 11.4623C8.4623 11.6217 8.22321 11.7655 7.98413 11.8938C8.11787 11.9313 8.25344 11.9616 8.39176 11.9826C8.58047 12.0129 8.77192 12.0284 8.96612 12.0284C9.06688 12.0284 9.16764 12.0239 9.26749 12.0156C10.0315 11.9533 10.7469 11.651 11.3258 11.1445C11.3881 11.0913 11.4476 11.0355 11.5063 10.9768C11.6437 10.8394 11.7683 10.6929 11.88 10.5381C11.9505 10.441 12.0165 10.3402 12.076 10.2367C10.8971 10.3603 9.74474 10.7689 8.7023 11.4623ZM9.76215 11.7298C9.88398 11.6657 10.0058 11.6061 10.1304 11.5512C10.0067 11.6071 9.88398 11.6666 9.76215 11.7298Z"
      fill="url(#paint5_linear_425_2265)"
    />
    <path
      d="M13.1816 10.2028C13.1431 10.2944 13.1019 10.3851 13.057 10.4739C12.9727 10.6434 12.8765 10.8083 12.7712 10.9668C12.7071 11.0629 12.6393 11.1564 12.5669 11.248C11.4265 11.2993 10.3007 11.6574 9.29762 12.3252C8.9422 12.5625 8.58586 12.7686 8.22952 12.9454C8.0793 12.9216 7.92998 12.8904 7.78433 12.851C7.54159 12.7869 7.30433 12.7017 7.07716 12.5982C6.95807 12.5442 6.84082 12.4846 6.72632 12.4205C7.14494 12.2941 7.56357 12.1191 7.98403 11.8938C8.11777 11.9313 8.25334 11.9616 8.39166 11.9826C8.58036 12.0129 8.77181 12.0284 8.96601 12.0284C9.06678 12.0284 9.16754 12.0239 9.26739 12.0156C10.0314 11.9533 10.7468 11.651 11.3257 11.1445C11.388 11.0913 11.4475 11.0355 11.5062 10.9768C11.6436 10.8394 11.7682 10.6929 11.8799 10.5381C11.9504 10.441 12.0164 10.3402 12.0759 10.2367C12.4433 10.1982 12.8124 10.1872 13.1816 10.2028Z"
      fill="url(#paint6_linear_425_2265)"
    />
    <path
      d="M15.895 13.0086C15.8492 13.0883 15.8025 13.1689 15.7539 13.2477C15.666 13.3897 15.5735 13.5289 15.4764 13.6663C15.4214 13.7442 15.3655 13.8202 15.3078 13.8962C13.3209 13.0901 11.1106 13.2889 9.29773 14.4953C7.9072 15.4214 6.50292 15.8904 5.1243 15.8904H5.12247C5.0501 15.8904 4.97682 15.8886 4.90445 15.8858C4.74323 15.7887 4.58659 15.6834 4.43269 15.5744C4.14506 15.371 3.87025 15.1475 3.60827 14.9039C3.53682 14.8379 3.46537 14.771 3.39575 14.7023C3.32247 14.6281 3.25193 14.5521 3.1814 14.4761C5.02537 15.1484 6.8446 14.8681 8.70231 13.6315C10.8761 12.186 13.5353 11.979 15.895 13.0086Z"
      fill="url(#paint7_linear_425_2265)"
    />
    <path
      d="M14.6198 14.6849C14.6143 14.6904 14.6097 14.6968 14.6042 14.7023C14.5319 14.7747 14.4577 14.8434 14.3826 14.913C14.2268 15.0577 14.0656 15.1952 13.8998 15.3261C13.7972 15.4068 13.6928 15.4855 13.5865 15.5606C12.1053 15.3894 10.5994 15.7365 9.29767 16.6022C9.07325 16.7524 8.8479 16.8889 8.62164 17.0144C8.45126 17.0061 8.2818 16.9915 8.11325 16.9732C7.81187 16.9393 7.51416 16.8889 7.22195 16.822C7.05706 16.7845 6.89309 16.7423 6.73096 16.6947C7.385 16.4968 8.04088 16.1781 8.70225 15.7384C10.4913 14.5484 12.61 14.1976 14.6198 14.6849Z"
      fill="url(#paint8_linear_425_2265)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_425_2265"
        x1="8.96693"
        y1="5.36564"
        x2="8.96693"
        y2="13.1954"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A088F2" />
        <stop offset="1" stop-color="#524FFB" />
        <stop offset="1.0001" stop-color="#524FFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_425_2265"
        x1="8.96785"
        y1="2.41022"
        x2="8.96785"
        y2="17.0299"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A088F2" />
        <stop offset="1" stop-color="#524FFB" />
        <stop offset="1.0001" stop-color="#524FFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_425_2265"
        x1="9.00327"
        y1="-2.97114"
        x2="9.00327"
        y2="27.7997"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A088F2" />
        <stop offset="1" stop-color="#524FFB" />
        <stop offset="1.0001" stop-color="#524FFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_425_2265"
        x1="14.6042"
        y1="9.85916"
        x2="14.6042"
        y2="13.3042"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A088F2" />
        <stop offset="1" stop-color="#524FFB" />
        <stop offset="1.0001" stop-color="#524FFB" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_425_2265"
        x1="4.82266"
        y1="11.0076"
        x2="4.82266"
        y2="14.9695"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A088F2" />
        <stop offset="1" stop-color="#524FFB" />
        <stop offset="1.0001" stop-color="#524FFB" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_425_2265"
        x1="10.0308"
        y1="9.93117"
        x2="10.0308"
        y2="12.9942"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A088F2" />
        <stop offset="1" stop-color="#524FFB" />
        <stop offset="1.0001" stop-color="#524FFB" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_425_2265"
        x1="9.95512"
        y1="9.72715"
        x2="9.95512"
        y2="14.4273"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A088F2" />
        <stop offset="1" stop-color="#524FFB" />
        <stop offset="1.0001" stop-color="#524FFB" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_425_2265"
        x1="9.5405"
        y1="11.7648"
        x2="9.5405"
        y2="17.7901"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A088F2" />
        <stop offset="1" stop-color="#524FFB" />
        <stop offset="1.0001" stop-color="#524FFB" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_425_2265"
        x1="10.6768"
        y1="14.039"
        x2="10.6768"
        y2="18.3844"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A088F2" />
        <stop offset="1" stop-color="#524FFB" />
        <stop offset="1.0001" stop-color="#524FFB" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Icon;
